type UserRole = 'doctor' | 'clinic_doctor' | 'admin' | null;

/**
 * Routes accessible only to users with the 'doctor' role.
 * clinic_doctor will be redirected to '/' when trying to access these routes.
 */
export const DOCTOR_ONLY_ROUTES = [
  '/payment',
  '/payment/checkout',
  '/payment/history',
  '/payment/bonus-history',
  '/payment/add-card',
  '/payment/credit-card',
];

/**
 * Returns true if the given role has access to the given path.
 * - Unprotected routes → accessible to all
 * - null role (session loading) → allow through; onMounted checks will handle it
 * - 'doctor' → full access
 * - 'clinic_doctor' → no access to protected routes
 */
export function hasAccessToRoute(path: string, role: UserRole): boolean {
  const isProtected = DOCTOR_ONLY_ROUTES.some(
    (r) => path === r || path.startsWith(r + '/'),
  );
  if (!isProtected) return true;
  if (role === null) return true;
  return role === 'doctor' || role === 'admin';
}
